module.exports = __webpack_public_path__ + "static/media/title01.305468a9.webp";